import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { CardBody as CardBody$1 } from '@chakra-ui/react';
import React from 'react';
var _excluded = ["children"];

var CardBody = function CardBody(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);
  /**
   * DOM
   */


  return /*#__PURE__*/React.createElement(CardBody$1, _extends({}, rest, {
    "data-object-type": "core-card-body"
  }), children);
};

CardBody.displayName = "CardBody";
export { CardBody };